import { render, staticRenderFns } from "./DispatchStatus.vue?vue&type=template&id=02a11126&scoped=true&"
import script from "./DispatchStatus.vue?vue&type=script&lang=js&"
export * from "./DispatchStatus.vue?vue&type=script&lang=js&"
import style0 from "./DispatchStatus.vue?vue&type=style&index=0&id=02a11126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a11126",
  null
  
)

export default component.exports